import { DELEGATE_ACCESS_ACTIONS } from '../constants';

const initialState = {
  isLoading: false,
};

const delegateAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELEGATE_ACCESS_ACTIONS.DELEGATE_ACCESS: {
      return Object.assign({}, state, {
        delegateAccessRecords: [].concat(
          state.delegateAccessRecords || [],
          action.payload.data
        ),
      });
    }
    case DELEGATE_ACCESS_ACTIONS.REGION_USER_LIST: {
      return {
        ...state,
        regionList: action.payload,
        delegateAccessRecords: action.payload.active_delegations,
        delegated: action.payload.delegated,
      };
    }
    case DELEGATE_ACCESS_ACTIONS.DELEGATE_ACCESS_RECORDS: {
      return { ...state, delegateAccessRecords: action.payload };
    }
    case DELEGATE_ACCESS_ACTIONS.REVOKE_ACCESS: {
      return Object.assign({}, state, {
        delegateAccessRecords: state.delegateAccessRecords.filter(
          (record) => record.id !== action.payload
        ),
      });
    }
    case 'LOGOUT': {
      return initialState;
    }

    default:
      return state;
  }
};

export default delegateAccessReducer;
